import React, { useCallback, useState, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { ImageActions } from "../_actions";
import { useApp } from "../_contexts";
import { BarLoader } from "react-spinners";
const MAX_FILESIZE_MB = 30;

export function FileDropzone({
  onChange,
  id,
  fileTypes = "image/jpeg,image/gif,image/png,image/svg+xml,image/webp",
  multiple = false,
  uploadMb = MAX_FILESIZE_MB,
  className = "chronos-file-dropzone",
  value,
  htmlImage,
  autoUpload = false,
  onUploadSuccess,
  onUploadFail,
  uploadProps,
}) {
  const [files, setFiles] = useState([]);
  const [thumbnails, setThumbnails] = useState([]);

  // const { data: chronicle } = useSelector((state) => state.chronicle);
  // const { details: world } = useSelector((state) => state.world);
  // const { loading } = useSelector((state) => state.images);

  // const dispatch = useDispatch();
  // const { user } = useApp();

  uploadMb = uploadMb ? uploadMb : MAX_FILESIZE_MB;

  const handleClear = (ev) => {
    ev.stopPropagation();
    setFiles([]);
    setThumbnails([]);
    // onChange(null);
    // ev.preventDefault();
    console.log("Clearing!", ev);
  };

  const onDrop = useCallback((acceptedFiles) => {
    setFiles(acceptedFiles);
    onChange(acceptedFiles);
  }, []);

  const onDropRejected = useCallback((files) => {
    for (let file of files) {
      for (let error of file.errors) {
        let message = "An error has occured";
        switch (error.code) {
          case "file-invalid-type":
            message = "File must be a jpeg, png, jpg, svg, or vmp file";
            break;
          case "file-too-large":
            message = `The file it too large, max file size is 30MB`;
            break;
          default:
            message = `${error.code} - ${error.message}`;
        }
        toast.error(message, { autoClose: 4000 });
      }
    }
  });

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    onDropRejected,
    accept: fileTypes,
    maxSize: uploadMb * 1024 * 1024,
    maxFiles: multiple ? 0 : 1,
    multiple: multiple,
  });

  useEffect(() => {
    // console.log('Files (hook)', files);
    if (files && files.length > 0) {
      const thumbs = files.map((file, idx) => {
        // console.log('FILE PREVIEW', file);
        return <ImageThumbnail key={idx} file={file} />;
      });
      setThumbnails(thumbs);
    }

    // onChange(files);
  }, [files]);

  useEffect(() => {
    // console.log("Initializing File Dropzone", value);
    if (typeof value === "string" && value.length > 0) {
      // console.log("Value type equals string!");
      setFiles([value]);
    } else if (Array.isArray(value) && value.length > 0) {
      // console.log("Value type is array");
      setFiles(value);
    }
  }, []);

  return (
    <div
      className={className + (isDragActive ? ` dropzone-highlight` : "")}
      {...getRootProps()}
    >
      {true && <ChronosUploadProgress />}

      <input {...getInputProps({ id })} />
      {(!files || files.length === 0) && (
        <>
          {isDragActive ? (
            <p className="chronos-file-dropzone-text chronos-file-dropzone-drop-text">
              {multiple && "Drop Files Here"}
              {!multiple && "Drop File Here"}
            </p>
          ) : (
            <p className="chronos-file-dropzone-text">
              {multiple && "Click or Drag & Drop files here"}
              {!multiple && "Click or Drag & Drop a single file here"}
              <span className="chronos-file-dropzone-text-small">
                Your current max filesize limit is {uploadMb} MB
              </span>
            </p>
          )}
        </>
      )}
      {files && files.length > 0 && (
        <div
          className={
            "chronos-file-dropzone-thumbnails" +
            (!multiple ? " single-file" : "")
          }
        >
          <p className="chronos-file-dropzone-message-top">
            Click or drop a new image here to replace the existing selection.
          </p>
          {thumbnails}
          <p
            className="chronos-file-dropzone-message-bottom"
            onClick={handleClear}
          >
            Click here to remove the image
          </p>
        </div>
      )}
    </div>
  );
}

function ImageThumbnail({ file }) {
  if (typeof file === "string") {
    let imgPath = "";
    if (file && file.length > 0) {
      imgPath = file;
    }
    return (
      <div className="chronos-file-dropzone-thumb" key={imgPath}>
        <div className="chronos-file-dropzone-thumb-inner">
          <img src={imgPath} className="chronos-file-dropzone-thumb-image" />
        </div>
      </div>
    );
  } else {
    console.log("FILE THUMB", file);
    const objectURL = URL.createObjectURL(file);
    return (
      <div className="chronos-file-dropzone-thumb" key={file.name}>
        <div className="chronos-file-dropzone-thumb-inner">
          <img src={objectURL} className="chronos-file-dropzone-thumb-image" />
        </div>
      </div>
    );
  }
}

function ChronosUploadProgress() {
  return (
    <div className="chronos-image-upload-progress-overlay">
      <BarLoader loading />
    </div>
  );
}
